import { Command } from 'commander';
import mcpServer from '../services/mcp-server';

const mcp = new Command('mcp')
  .description(
    'Start the MCP server (with STDIO transport; for use with an MCP client)'
  )
  .action(mcpServer.start);

export default mcp;
